import { useCallback, useState } from 'react'

import { useGetText } from 'shared/i18n'

import {
  AuthenticatedUser,
  Credentials,
  LoginFailureCode,
  language,
  useLogIn as useAuthLogin,
} from 'shared/auth'

export default function useLogIn() {
  const [failure, setFailure] = useState<LoginFailureCode>()
  const { setLocale } = useGetText()

  const onSuccess = useCallback(
    async (user: AuthenticatedUser) => {
      await setLocale(language(user))
    },
    [setLocale],
  )

  const onFailure = useCallback(setFailure, [setFailure])

  const authLogin = useAuthLogin(onSuccess, onFailure)

  const logIn = useCallback(
    async (credentials: Credentials) => {
      setFailure(undefined)
      await authLogin(credentials)
    },
    [authLogin, setFailure],
  )

  return {
    logIn,
    failure,
  }
}
